import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/api";
import { PageHeader } from "@/pages/admin/AdminDashboard";
import { toast } from "sonner";

export default function SalarieMessages() {
  const [items, setItems] = useState([]);

  const load = async () => {
    try {
      const { data } = await api.get("/salarie/notifications");
      setItems(data);
      // Mark all as read
      for (const n of data.filter((x) => !x.read)) {
        api.post(`/salarie/notifications/${n.id}/read`).catch(() => {});
      }
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="min-h-full">
      <PageHeader eyebrow="Messagerie" title="Mes messages" sub="Messages reçus de votre chef d'entreprise." />
      <div className="p-6 lg:p-10 space-y-3" data-testid="salarie-messages-list">
        {items.length === 0 ? (
          <div className="bg-white border border-[#DEE2E6] p-8 text-center text-sm text-[#868E96]">Aucun message.</div>
        ) : items.map((n) => (
          <div key={n.id} className={`bg-white border p-5 ${!n.read ? "border-[#002FA7]" : "border-[#DEE2E6]"}`} data-testid={`message-${n.id}`}>
            <div className="flex justify-between items-start mb-2">
              <div className="font-display font-bold text-base flex items-center gap-2">
                {!n.read && <span className="h-2 w-2 bg-[#002FA7]" />}
                {n.title}
              </div>
              <div className="text-xs text-[#868E96]">{new Date(n.created_at).toLocaleString("fr-FR")}</div>
            </div>
            <p className="text-sm text-[#495057] whitespace-pre-wrap">{n.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
